import React, { useState, useEffect } from "react";
import axios from "axios";
import "./TasksTableForBuyTaxi.css";

const TasksTableForBuyTaxi = () => {
  const [tasks, setTasks] = useState([]);
  const [editTask, setEditTask] = useState(null);
  const [updatedTask, setUpdatedTask] = useState({});

  useEffect(() => {
    fetchTasks();
    const interval = setInterval(fetchTasks, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchTasks = async () => {
    try {
      const response = await axios.get("/api/tasks/all");
      setTasks(response.data.data);
    } catch (error) {
      console.error("❌ שגיאה בשליפת משימות:", error);
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
  };

  const handleEdit = (task) => {
    setEditTask(task.id);
    setUpdatedTask({ ...task });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedTask((prevTask) => ({
      ...prevTask,
      [name]: value,
    }));
  };

  const handleSave = async (id) => {
    try {
      await axios.put(`/api/tasks/update/${id}`, updatedTask);
      alert("✅ המשימה עודכנה בהצלחה!");
      setEditTask(null);
      fetchTasks();
    } catch (error) {
      console.error("❌ שגיאה בעדכון משימה:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("❗ האם אתה בטוח שברצונך למחוק את המשימה?")) {
      try {
        await axios.delete(`/api/tasks/delete/${id}`);
        alert("🗑️ המשימה נמחקה בהצלחה!");
        fetchTasks();
      } catch (error) {
        console.error("❌ שגיאה במחיקת משימה:", error);
      }
    }
  };

  return (
    <div className="tasks-container-TasksTableForBuyTaxi">
      <h2 className="tasks-title-TasksTableForBuyTaxi">📋 רשימת משימות</h2>
      <table className="tasks-table-TasksTableForBuyTaxi">
        <thead>
          <tr>
            <th>שם המשימה</th>
            <th>תאריך יצירה</th>
            <th>תיאור</th>
            <th>אזור</th>
            <th>עמוד</th>
            <th>סטטוס</th>
            <th>הערות</th>
            <th>תאריך ביצוע</th>
            <th>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id}>
              {editTask === task.id ? (
                <>
                  <td><input type="text" name="task_name" value={updatedTask.task_name} onChange={handleInputChange} /></td>
                  <td><input type="date" name="task_date" value={updatedTask.task_date} onChange={handleInputChange} /></td>
                  <td><input type="text" name="task_description" value={updatedTask.task_description} onChange={handleInputChange} /></td>
                  <td><input type="text" name="task_area" value={updatedTask.task_area} onChange={handleInputChange} /></td>
                  <td><input type="text" name="task_page" value={updatedTask.task_page} onChange={handleInputChange} /></td>
                  <td>
                    <select name="status" value={updatedTask.status} onChange={handleInputChange}>
                      <option value="בוצע">בוצע</option>
                      <option value="בתהליך">בתהליך</option>
                      <option value="לא בוצע">לא בוצע</option>
                    </select>
                  </td>
                  <td><input type="text" name="notes" value={updatedTask.notes} onChange={handleInputChange} /></td>
                  <td><input type="date" name="execution_date" value={updatedTask.execution_date} onChange={handleInputChange} /></td>
                  <td>
                    <button onClick={() => handleSave(task.id)}>💾 שמירה</button>
                  </td>
                </>
              ) : (
                <>
                  <td>{task.task_name}</td>
                  <td className="tasks-td-TasksTableForBuyTaxi-date">{formatDate(task.task_date)}</td>
                  <td>{task.task_description}</td>
                  <td>{task.task_area}</td>
                  <td>{task.task_page}</td>
                  <td>{task.status}</td>
                  <td>{task.notes}</td>
                  <td className="tasks-td-TasksTableForBuyTaxi-date">{formatDate(task.execution_date)}</td>
                  <td>
                    <button onClick={() => handleEdit(task)}>✏️ עריכה</button>
                    <button onClick={() => handleDelete(task.id)}>🗑️ מחיקה</button>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TasksTableForBuyTaxi;